import React, { useRef, useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import { Banner, MainContent, Technology } from "../Contents";
import Header from "../Header/Header";
import Feature from "../Contents/Feature";
import MobileAppCard from "../Card/MobileAppCard";
import Footer from "../Footer/Footer";

const HomeLayout = () => {
  const mobileAppCardRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
     
        if (entry.isIntersecting) {
          setIsVisible(true);
   
          observer.disconnect();
        }
      },
      {
        threshold: 0.5, 
      }
    );

    const currentRef = mobileAppCardRef.current;

    if (currentRef) {
      observer.observe(currentRef);
    }


    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, [mobileAppCardRef]);

  return (
    <div className="flex flex-col bg-white">
      <Header />
      <Navbar />
      <div>

        <MainContent />
        <Technology />
        <Banner />
        <Feature />
        <div ref={mobileAppCardRef}>
          <MobileAppCard isVisible={isVisible} />
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default HomeLayout;
